import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { CoverageAreaManagementPage } from '@/features/devices'

export const Route = createFileRoute('/_authenticated/devices/coverage-areas')({
  component: () => (
    <RequirePermission permission='coverage_areas.read'>
      <CoverageAreaManagementPage />
    </RequirePermission>
  ),
})
